import * as React from "react";
export class Icon extends React.PureComponent {
    render() {
        return React.createElement("span", { className: `icon${typeof this.props.i === "string" ? ` ${this.props.i}` : ""}`, "data-uat": this.props.dataUat });
    }
}
//# sourceMappingURL=Icon.js.map